export const ID = '7f7f34b5-9cb9-4f46-b137-1c6790a95a14';

export const NAME = 'Units Table 2: Circles';
